<template>
    <div>
        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :close-on-click-modal="false"
            width="400px"
            class="resetPassword">
            <p class="login-title"><span>{{$t('app.retrievePwd')}}</span></p>
            <el-form v-if="isReset" class="reset-form" :model="formData" :rules="resetRules" ref="resetForm">
                <el-form-item class="reset-item" prop="mobile">
                    <img src="../../assets/images/login/mobile.png" alt="mobile">
                    <el-input type="text" v-model="formData.mobile" class="code"
                              :placeholder="$t('tip.mobile')"/>
                </el-form-item>
                <el-form-item class="reset-item" prop="checkCode">
                    <img src="../../assets/images/login/mobile_code.png" alt="code">
                    <el-input type="text" v-model="formData.checkCode"
                              :placeholder="$t('tip.code')" style="width: 58%"/>
                    <el-button class="btn-code" @click="postCode" :disabled="!isMobileValid || codeStatus===1">
                        {{codeText}}
                    </el-button>
                </el-form-item>
                <el-form-item class="reset-item" prop="newPwd">
                    <img src="../../assets/images/login/pwd.png" alt="newPwd">
                    <el-input type="password" v-model="formData.newPwd"
                              :placeholder="$t('tip.newPwd')"/>
                </el-form-item>
                <el-form-item class="reset-item" prop="confirmPwd">
                    <img src="../../assets/images/login/pwd.png" alt="confirmPwd">
                    <el-input type="password" v-model="formData.confirmPwd"
                              :placeholder="$t('tip.confirmPwd')"/>
                </el-form-item>
                <el-form-item class="reset-item">
                    <el-button class="but_a" size="small" @click="resetSubmit('resetForm')">{{$t('app.confirmEdit')}}
                    </el-button>
                </el-form-item>
            </el-form>
            <div v-else class="reset-success">
                <img src="../../assets/images/login/right.png" alt="right"/>
                <p>{{$t('app.resetSuccess', [successTimer])}}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import api from '@/api';
    import {Exp} from "@/config/constant";

    export default {
        props: {
            dialogOpen: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            let moblieOccupation = (rule, value, callback) => {
                api.mobileOccupation({mobile: value}).then(res => {
                    let exist = res.package;
                    if (!exist) {
                        this.isMobileValid = false;
                        callback(new Error(this.$t('rule.mobileNotExist')));
                    } else {
                        this.isMobileValid = true;
                        callback();
                    }
                });
            };

            let validatePass = (rule, value, callback) => {
                if (this.formData.confirmPwd !== "") {
                    this.$refs.resetForm.validateField("confirmPwd");
                }
                callback();
            };
            let validatePass2 = (rule, value, callback) => {
                if (value !== this.formData.newPwd) {
                    callback(new Error(this.$t('app.errorPwd')));
                } else {
                    callback();
                }
            };

            return {
                visible: false,
                isReset: true,
                formData: {
                    mobile: '',
                    checkCode: '',
                    newPwd: '',
                    confirmPwd: ''
                },
                resetRules: {
                    mobile: [
                        {required: true, message: this.$t('tip.mobile'), trigger: "blur"},
                        {pattern: Exp.mobile, message: this.$t('app.errorMobile'), trigger: "blur"},
                        {validator: moblieOccupation, trigger: "blur"}
                    ],
                    checkCode: [
                        {required: true, message: this.$t('tip.code'), trigger: "blur"}
                    ],
                    newPwd: [
                        {required: true, message: this.$t('tip.newPwd'), trigger: "blur"},
                        {pattern: Exp.password, message: this.$t('rule.pwd'), trigger: "blur"},
                        {validator: validatePass, trigger: "blur"}
                    ],
                    confirmPwd: [
                        {required: true, message: this.$t('tip.confirmPwd'), trigger: "blur"},
                        {pattern: Exp.password, message: this.$t('rule.pwd'), trigger: "blur"},
                        {validator: validatePass2, trigger: "blur"}
                    ]
                },

                isMobileValid: false,
                codeStatus: 0, // 0: 未发送 1：已发送 2：重新获取
                codeTimer: 0, // 倒计时验证码
                successTimer: 0, // 倒计时充值成功跳转
            }
        },
        created() {
        },
        computed: {
            codeText() {
                return [this.$t('app.getCode'), this.$t('app.waitCode', [this.codeTimer]), this.$t('app.getCodeAgain')][this.codeStatus];
            },
        },
        methods: {
            initDialog() {
                this.$refs.resetForm && this.$refs.resetForm.resetFields()
            },

            postCode() {
                if (!this.bindingMobile) {
                    let isValid = true;
                    this.$refs.resetForm.validateField("mobile", errMsg => {
                        if (errMsg) isValid = false;
                    });
                    if (!isValid) return;
                }

                if (!(this.codeStatus === 0 || this.codeStatus === 2)) return;

                this.codeTimer = 60;
                this.codeStatus = 1;

                let data = {
                    mobile: this.formData.mobile
                };
                api
                    .smsapiSend(data)
                    .then(res => {
                        this.$message.success(this.$t('m.checkCode'));

                        clearInterval(window.timeHandler);
                        window.timeHandler = setInterval(() => {
                            this.codeTimer--;

                            if (this.codeTimer <= 0) {
                                clearInterval(window.timeHandler);
                                this.codeStatus = 2;
                            }
                        }, 1000);
                    })
                    .catch(error => {
                        this.codeStatus = 0;
                    });
            },

            resetSubmit(formName) {
                this.$refs[formName].validate(valid => {
                    if (!valid) return;
                    this.successTimer = 3;
                    api.ForgetPassword(this.formData).then(res => {
                        this.isReset = false;
                        window.timeHandler = setInterval(() => {
                            this.successTimer--;
                            if (this.successTimer <= 0) {
                                clearInterval(window.timeHandler);
                                this.visible = false;
                            }
                        }, 1000);
                    });
                });
            },
        },
        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.initDialog();
                    // 关闭
                } else {
                    this.$emit('update:dialogOpen', false)
                }
            },
            dialogOpen(v) {
                this.visible = v;
            }
        },
    }
</script>

<style lang="scss">
    @import "../../style/const";

    $mainColor: #4081dd;
    $borderColor: #999;

    .resetPassword {
        .login-title {
            width: 90%;
            color: #2b2223;
            font-size: 20px;
            text-align: left;
            margin: 0 auto 3vh;
            border-bottom: 1px solid $borderColor;
            padding-bottom: 4px;

            span {
                padding: 0 5px 4px;
                border-bottom: 3px solid $mainColor;
            }
        }

        .reset-form {
            width: 90%;
            margin: auto;
        }

        .reset-item /deep/ .el-input__inner {
            padding: 0 15px 0 30px;
        }

        .reset-item {
            width: 100%;
            position: relative;
            margin: 15px auto;
            padding-bottom: 5px;

            img {
                width: 12px;
                position: absolute;
                z-index: 10;
                left: 8px;
                color: $borderColor;
                top: 10px;
            }

            .btn-code {
                width: 41%;
                float: right;
            }

            .but_a {
                width: 100%;
                background: $mainColor;
                color: #fff;
                font-size: 16px;
            }
        }

        .reset-success {
            text-align: center;

            p {
                margin: 3vh;
            }
        }

        .el-dialog__header {
            border-bottom: none;
        }
    }
</style>
